import { SignedOut } from "@clerk/clerk-expo";
import { useContext } from "react";
import { View } from "tamagui";

import AuthenticationBar from "./AuthenticationBar";
import { Header } from "./Layout";
import { LayoutContext } from "./LayoutProvider";

export const NoriHeader = () => {
  const { headerHeight, showHeader } = useContext(LayoutContext);
  if (!showHeader) {
    return null;
  }
  return (
    <Header
      position="absolute"
      top={0}
      width="100%"
      minHeight="$headerHeight"
      justifyContent="center"
      zIndex={1}
      onLayout={(e) => {
        const height = e.nativeEvent.layout.height;
        if (height === 0) return;
        headerHeight.current = height;
      }}
    >
      <View
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        backdropFilter="blur(10px)"
        borderTopLeftRadius="$screenBorderRadius"
        borderTopRightRadius="$screenBorderRadius"
        style={{
          maskImage:
            "linear-gradient(to bottom, black 40%, rgba(0, 0, 0, 0.95) 60%, rgba(0, 0, 0, 0.85) 70%, rgba(0, 0, 0, 0.7) 80%, rgba(0, 0, 0, 0.4) 90%, rgba(0, 0, 0, 0.1) 95%, transparent 100%)",
        }}
      />
      <SignedOut>
        <AuthenticationBar />
      </SignedOut>
    </Header>
  );
};
